import { Center, Flex, Group, Text } from '@mantine/core';

import { MinStdDownloadableReportButton } from '@/module/MinimalStandard/components/MinStdDownloadableReportButton';

import { Content } from '@/core/components';

import { JobTitle } from '@feature/utils';

import { MinStdReport } from '../model/MinStdTypes';

export interface MinStdHeaderProps {
  report: MinStdReport;

  jobTitle: JobTitle | null;
  startYear: number;
  endYear: number;
}

export function MinStdHeader({ report, jobTitle, startYear, endYear }: MinStdHeaderProps) {
  return (
    <Content type="full">
      <Flex
        justify="center"
        align="center"
        gap="4px"
      >
        <Text fw="500">Anexa nr. {report.minStdAnnexNo}</Text>
      </Flex>
      {report.implemented && (
        <Center component={Group}>
          <MinStdDownloadableReportButton
            authorId={report.user.id}
            fileType="pdf"
            jobTitle={jobTitle}
            startYear={startYear}
            endYear={endYear}
          />
          <MinStdDownloadableReportButton
            authorId={report.user.id}
            fileType="docx"
            jobTitle={jobTitle}
            startYear={startYear}
            endYear={endYear}
          />
        </Center>
      )}
    </Content>
  );
}
